import styled from '@emotion/styled';

import { customPalette } from '../../../styles/theme';

export const AvatarContainer = styled.div<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  background-color: ${customPalette.accent.defaultGreen};
  border: 2px solid ${customPalette.accent.white};
  display: flex;
  align-items: center;
  justify-content: center;
`;
